import * as React from 'react';
import { translationForMts } from 'easit--localization';

export interface IFindTicketByNumberProps {
    ticketNumber: string;
    onTicketNumberChange: (value: string) => void;
    onGo: () => void;
}

export const FindTicketByNumberComponent: React.FC<IFindTicketByNumberProps> = (props: IFindTicketByNumberProps) => {
    const [validNumber, setValidNumber] = React.useState<boolean>(!isNaN(Number(props.ticketNumber))/* same in onChange */);
    const t = translationForMts();

    return (
        <div className="find-ticket-wrapper">
            <form onSubmit={(evt) => {
                evt.preventDefault();
                evt.stopPropagation();
                if (props.ticketNumber.length < 10 /* ad hoc, should be more, important is empty */) {
                    setValidNumber(false);
                    return false;
                }
                if (validNumber) {
                    props.onGo();
                }
                return false;
            }}
            >
                <div className="header">{t.findTicketByNumber_title}</div>
                <div className="find-ticket-content">
                    <div >{t.findTicketByNumber_InfoText}</div>
                    <div className="input-wrapper">
                        <input
                            type="text"
                            className={`find-ticket-input ${!validNumber ? 'invalid' : ''}`}
                            value={props.ticketNumber}
                            onChange={(e) => { setValidNumber(!isNaN(Number(e.target.value))); props.onTicketNumberChange(e.target.value) }}
                            placeholder={t.findTicketByNumber_Placeholder}
                        />
                        <input
                            disabled={!validNumber}
                            className="btn btn-primary find-ticket-submit"
                            type="submit"
                            value={t.findTicketByNumber_buttonSend}
                        />
                    </div>
                </div>
            </form>
        </div >)
};
